import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-black text-white text-center w-10/12" }, "Set new password", -1)
const _hoisted_2 = { class: "w-full align-middle mt-[50px] flex flex-col gap-6 bg-white shadow-base h-fit rounded-3xl px-5 py-10" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "w-full flex flex-col items-center justify-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-center pt-5" }, [
  /*#__PURE__*/_createTextVNode("Didn’t receive an email? "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/reset-password",
    class: "text-primary-violet"
  }, "Resend code")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)

import { ref, onMounted, computed } from "vue"
  import { IonPage } from "@ionic/vue"
  import { generateSchema } from "@/utils/validate"
  import { useAuthenticationStore } from "@/store/authentication"
  import * as jwt from "@/utils/jwt"
  import { useRouter } from "vue-router"
  import { toastController } from "@ionic/vue"

  import WbTemplate from "@/components/account-creation/template.vue"
  import WbPassword from "@/components/template/PasswordTemplate.vue"
  import SixDigitContainer from "@/components/template/SixdigitCode.vue"
  import FormContainer from "@/components/template/formTemplate.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SetPassword',
  setup(__props) {

  const confirmpassword = ref("")
  const authenticationStore = useAuthenticationStore()
  const passedEMail = computed(() => useRouter().currentRoute.value?.query?.email.toString())

  const changePassword = computed({
    get: () => authenticationStore.resetPassword,
    set: (val) => {
      authenticationStore.setResetPassword(val)
    },
  })

  const validationSchema = generateSchema([
    {
      name: "password",
      rule: "password",
    },
    {
      name: "sixDigitCode",
      rule: "sixDigitCode",
    },
    {
      name: "confirmpassword",
      rule: "stringRequired",
    },
  ])

  onMounted(() => {
    if (useRouter().currentRoute.value.query.email) {
      authenticationStore.resetPassword.email = passedEMail.value
    } else {
      window.location.href = "reset-password"
    }
  })

  const setNewPassword = async () => {
    if (confirmpassword.value === authenticationStore.resetPassword.password) {
      authenticationStore.resetUserPassword(jwt.default.generateNBF())
    } else {
      const toast = await toastController.create({
        message: "Confirmation password does not match.",
        duration: 3000,
        position: "top",
        color: "danger",
      })
      await toast.present()
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(WbTemplate, null, {
        default: _withCtx(() => [
          _createVNode(FormContainer, {
            "validation-schema": _unref(validationSchema),
            class: "flex flex-col w-[25rem] items-center justify-center text-light-black",
            onValid: setNewPassword
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, "Please enter the 6 digit code sent to " + _toDisplayString(_unref(passedEMail)), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(SixDigitContainer, {
                    modelValue: _unref(changePassword).code,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(changePassword).code) = $event)),
                    name: "sixDigitCode",
                    "aria-autocomplete": "off"
                  }, null, 8, ["modelValue"]),
                  _hoisted_5
                ]),
                _createVNode(WbPassword, {
                  modelValue: _unref(changePassword).password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(changePassword).password) = $event)),
                  autocomplete: "new-password",
                  name: "password",
                  placeholder: "New password*"
                }, null, 8, ["modelValue"]),
                _createVNode(WbPassword, {
                  modelValue: confirmpassword.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmpassword).value = $event)),
                  name: "confirmpassword",
                  placeholder: "Confirm new password*"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ion_button, {
                  expand: "block",
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Continue")
                  ]),
                  _: 1
                }),
                _hoisted_6
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})